import { Box } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";

import TabPanel from "../../../../shared/UI/TabPanel";

import { useEntityBranch } from "../../../Entity/api/queries/useEntityBranch";
import { EntityBranchDetails } from "../../../Entity/api/types/entityBranches.types";

import SportsTab from "./SportsTab";
import FacilitiesTab from "./FacilitiesTab";
import TabsNavigation from "./TabsNavigation";
import WorkingHoursTab from "./WorkingHoursTab";

const TABS = [
  {
    value: "workingDays",
    component: (isLoading: boolean, branchData?: EntityBranchDetails) => (
      <WorkingHoursTab branchData={branchData} isBranchDataLoading={isLoading} />
    ),
  },
  {
    value: "sports",
    component: (isLoading: boolean, branchData?: EntityBranchDetails) => (
      <SportsTab branchData={branchData} isBranchDataLoading={isLoading} />
    ),
  },
  {
    value: "facilities",
    component: (isLoading: boolean, branchData?: EntityBranchDetails) => (
      <FacilitiesTab branchData={branchData} isBranchDataLoading={isLoading} />
    ),
  },
];

const EntityProfileBranch = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "facilities";

  const { data, isLoading } = useEntityBranch(branchId!);

  return (
    <Box sx={styles.container}>
      <TabsNavigation branchData={data} isBranchDataLoading={isLoading} />
      <Box sx={styles.tabsContainer}>
        {TABS.map((tab) => (
          <TabPanel key={tab.value} value={currentTab} tab={tab.value}>
            {tab.component(isLoading, data)}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default EntityProfileBranch;

const styles = {
  container: { display: "flex", flexDirection: "column", gap: "16px" },
  tabsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "24px 0",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  },
};
